import { Controller } from "@hotwired/stimulus"

// On a select of region codes (ISO 3166, like "GB") with nothing chosen yet, chooses the region the browser's
// time zone belongs to, and fires change as if the user had chosen it. It leaves any choice already made alone.
// Both sides come from the browser's own time zone data, so their zone names always agree.
export default class extends Controller {
  connect() {
    if (this.element.value) return

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const option = Array.from(this.element.options).find((option) => this.timeZones(option.value).includes(timeZone))
    if (!option) return

    this.element.value = option.value
    this.element.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // Browsers that shipped this before it became a method expose it as the timeZones property.
  timeZones(region) {
    if (!region) return []

    const locale = new Intl.Locale(`und-${region}`)
    return locale.getTimeZones?.() ?? locale.timeZones ?? []
  }
}
